import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { addOrUpdateFormField } from '../store/applicationform';
import { useAppDispatch } from './hooks';

const PARAM_CONSENT_ID = 'consent_id';
const PARAM_CONSENT_STATE = 'consent_state';
const CONSENT_STATE_ERROR = 'error';
const CONSENT_STATE_SUCCESS = 'success';
const CO_APPLICANT_NORSK_GJELD_REFERENCE_ID = 'coapplicantGjeldsregisteretId';
const APPLICANT_NORSK_GJELD_REFERENCE_ID = 'applicantGjeldsregisteretId';

/**
 * Monitors the query params if there is a consent state and id.
 * The query params will be removed and the consent id will be added
 */
export const useConsentIdParams = (governmentId: string) => {
    const [params, setParams] = useSearchParams();
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (params.get(PARAM_CONSENT_STATE)) {
            if (params.get(PARAM_CONSENT_STATE) === CONSENT_STATE_SUCCESS && params.get(PARAM_CONSENT_ID)) {
                dispatch(
                    addOrUpdateFormField({
                        fieldName:
                            governmentId === 'applicantGovernmentId'
                                ? APPLICANT_NORSK_GJELD_REFERENCE_ID
                                : CO_APPLICANT_NORSK_GJELD_REFERENCE_ID,
                        value: params.get(PARAM_CONSENT_ID) ?? undefined,
                        hasError: false,
                    }),
                );
            } else if (params.get(PARAM_CONSENT_STATE) === CONSENT_STATE_ERROR) {
                dispatch(
                    addOrUpdateFormField({
                        fieldName:
                            governmentId === 'applicantGovernmentId'
                                ? APPLICANT_NORSK_GJELD_REFERENCE_ID
                                : CO_APPLICANT_NORSK_GJELD_REFERENCE_ID,
                        value: undefined,
                        hasError: true,
                    }),
                );
            }

            params.delete(PARAM_CONSENT_ID);
            params.delete(PARAM_CONSENT_STATE);
            setParams(params);
        }
    }, [params]);
};
